import { render, staticRenderFns } from "./NotIndex.vue?vue&type=template&id=be0ea300"
import script from "./NotIndex.vue?vue&type=script&lang=js"
export * from "./NotIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports